import type { ServiceCategories } from '@shared/services/systemSettings/types/getAppServices.types';

import type { IEservices, IEservicesGroupExtraMap, IEservicesModuleExtraMap } from '../types/eservices';

const formatEServices = (
  serviceCategories: ServiceCategories[],
  eservicesModuleExtraMap?: IEservicesModuleExtraMap,
  eservicesGroupExtraMap?: IEservicesGroupExtraMap
): IEservices[] =>
  serviceCategories.map((serviceCategory) => {
    const serviceCategoryDescription = serviceCategory.Groups.find(
      (group) => group.Label === serviceCategory.Label
    )?.Description;

    return {
      description: serviceCategoryDescription,
      extra: eservicesGroupExtraMap?.[serviceCategory.Label]?.extra,
      groups: serviceCategory.Groups.map((group) => ({
        description: group.Description,
        label: group.Label,
        modules: group.Services.map((service) => ({
          description: service.Description ?? '',
          icon: service.Image,
          isPopular: service.IsPopular,
          label: service.Label,
          onClick: eservicesModuleExtraMap?.[service.Code]?.onClick,
          publicDescription: service.PublicLabel,
          publicUrl: service.PublicUrl,
          url: service.Action,
          searchTags: service.SearchTags,
        })),
      })),
      label: serviceCategory.Label,
    };
  });

export { formatEServices };
